import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import MainMenu from "./MainMenu";

class Routing extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <MainMenu />
        </div>
      </BrowserRouter>
    );
  }
}

export default Routing;
